import { apiClient } from "../client";
import type { UserSubscription } from "./types";

async function unsubscribeUser(subscriptionId: string): Promise<void> {
  const { error } = await apiClient.DELETE("/subscriptions/{id}", {
    params: { path: { id: subscriptionId } },
  });
  if (error) throw new Error("Failed to unsubscribe user");
}

async function getUserSubscription(): Promise<UserSubscription | null> {
  const { data, response, error } = await apiClient.GET("/subscriptions/my");
  if (response.status === 404) return null;
  if (error || !data) throw new Error("Failed to load subscription");
  return data;
}

export const apiSubscription = {
  unsubscribeUser,
  getUserSubscription,
};
